import { render } from "./BulkMessageSettings.vue?vue&type=template&id=7a12e5eb&scoped=true&ts=true"
import script from "./BulkMessageSettings.vue?vue&type=script&lang=ts"
export * from "./BulkMessageSettings.vue?vue&type=script&lang=ts"

import "./BulkMessageSettings.vue?vue&type=style&index=0&id=7a12e5eb&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a12e5eb"]])

export default __exports__